export const SELLER_GROUP_ACTIONS = {
  ACTIVE: true,
  DISABLED: false,
};

export const CUSTOMER_DETAIL_TABS = {
  CUSTOMER_INFO: "CUSTOMER_INFO",
  AGENT_LIST: "AGENT_LIST",
};
